<template>
  <div>
    <div v-show="group.loading">
      <v-skeleton-loader type="table" />
    </div>
    <EditAssignedUsers v-if="group.value && !group.loading" :group="group.value" class="ma-3" />
  </div>
</template>

<script>
import EditAssignedUsers from '@/components/manage/groups/manage-group/assigned-users/EditAssignedUsers.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapActions, mapState } = createNamespacedHelpers('groups');

export default {
  components: {
    EditAssignedUsers
  },
  computed: mapState({
    group: state => state.groupAssignment.selectedGroup
  }),
  mounted() {
    // TODO: add validation for groupId
    this.getGroupForEdit({ groupId: this.$route.params.groupId });
  },
  methods: mapActions(['getGroupForEdit'])
};
</script>

<style lang="scss" scoped>
.search-box {
  width: 600px;
}
</style>
